export default __webpack_public_path__ + "static/media/cover-codes-guide.6dded089.png";